// src/AddressSearch.jsx
import React, { useRef, useEffect } from 'react';

const checkDSTLeconfieldLocation = (name, formattedAddress, vicinity) => {
  // Convert to lowercase for case-insensitive matching
  const nameL = name.toLowerCase();
  const addressL = formattedAddress.toLowerCase();
  const vicinityL = vicinity.toLowerCase();
  
  // Check specifically for DST Leconfield and related military facilities
  const dstKeywords = [
    'dst leconfield',
    'defence school of transport',
    'defense school of transport',
    'raf leconfield',
    'royal air force leconfield',
  ];
  
  // Check if any DST keyword appears in name, address, or vicinity
  for (const keyword of dstKeywords) {
    if (nameL.includes(keyword) || addressL.includes(keyword) || vicinityL.includes(keyword)) {
      return true;
    }
  }
  
  return false;
};

const showDSTLeconfieldDialog = () => {
  const modal = document.createElement('div');
  modal.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
    font-family: Arial, sans-serif;
  `;
  
  const dialog = document.createElement('div');
  dialog.style.cssText = `
    background: white;
    padding: 24px;
    border-radius: 12px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
    max-width: 400px;
    margin: 20px;
    text-align: left;
  `;
  
  dialog.innerHTML = `
    <h3 style="margin: 0 0 16px 0; color: #00ab86; font-size: 18px;">DST Leconfield Pickup Info</h3>
    <p style="margin: 0 0 16px 0; line-height: 1.5; color: #333; font-size: 14px;">
      If you require pickup at Grange Road, please put pickup as 'Grange Road, Leconfield'. 
      If not, we will pick you up at the main road entrance!<br><br>
      Most personnel use Grange Road entrance for pickups.
    </p>
    <button id="dst-ok-btn" style="
      background: #00ab86;
      color: white;
      border: none;
      padding: 10px 20px;
      border-radius: 6px;
      cursor: pointer;
      font-size: 14px;
      font-weight: bold;
    ">OK, I understand</button>
  `;
  
  modal.appendChild(dialog);
  document.body.appendChild(modal);
  
  const okButton = document.getElementById('dst-ok-btn');
  okButton.addEventListener('click', () => {
    document.body.removeChild(modal);
  });
  
  // Close on background click
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      document.body.removeChild(modal);
    }
  });
};

const AddressSearch = ({ onSelect, placeholder }) => {
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);

  useEffect(() => {
    if (!window.google || !window.google.maps || !window.google.maps.places) return;

    const defaultBounds = new window.google.maps.LatLngBounds(
      { lat: 53.7, lng: -0.5 }, // SW corner
      { lat: 54.0, lng: -0.1 }  // NE corner
    );

    autocompleteRef.current = new window.google.maps.places.Autocomplete(inputRef.current, {
      componentRestrictions: { country: 'gb' },
      bounds: defaultBounds,
      strictBounds: false,
    });

    autocompleteRef.current.addListener('place_changed', () => {
      const place = autocompleteRef.current.getPlace();
      if (!place.geometry) return;

      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      const name = place.name || '';
      const address = place.formatted_address || '';
      const vicinity = place.vicinity || '';
      
      // Check for DST Leconfield and show pickup guidance
      const isDSTLeconfield = checkDSTLeconfieldLocation(name, address, vicinity);
      if (isDSTLeconfield) {
        showDSTLeconfieldDialog();
      }
      
      const fullLabel = name && address.includes(name) ? address : `${name}, ${address}`;
      onSelect({ lat, lng }, fullLabel);
    });
  }, [onSelect]);

  return (
    <input
      ref={inputRef}
      type="text"
      placeholder={placeholder}
      className="address-input"
      style={{
        padding: '12px',
        borderRadius: '7px',
        border: '2px solid #00ab86',
        width: '100%',
        fontSize: '16px',
        backgroundColor: 'white',
      }}
    />
  );
};

export default AddressSearch;